const getOfferFromURL = () => {
  const splittedURL = window.location.pathname.replace(/\/$/, '').split('/');
  const offerId = parseInt(splittedURL[1], 10);

  // eslint-disable-next-line no-restricted-globals
  if (isNaN(offerId)) return 0;

  return splittedURL.length >= 2 ? offerId : 0;
};

const isPathWithoutOffer = () => {
  const splittedURL = window.location.pathname.replace(/\/$/, '').split('/');
  if (splittedURL.length === 2) {
    if (splittedURL[0].length === 0 && splittedURL[1].length > 0) return true;
  }

  return false;
};

export { getOfferFromURL, isPathWithoutOffer };
